import { gql } from "@apollo/client";

export const GET_MESSAGE_THREADS = gql`
  query GetMessageThreads($userId: ID!, $role: UserAccountType!) {
    getMessageThreads(userId: $userId, role: $role) {
      _id
      participants {
        userId
        role
        displayName
        avatarUrl
        lastReadAt
      }
      lastMessage {
        _id
        threadId
        senderId
        senderRole
        body
        attachments {
          _id
          url
          path
          title
        }
        replyTo {
          _id
          senderId
          senderRole
          body
          attachments {
            _id
            url
            path
            title
          }
          createdAt
          updatedAt
        }
        reactions {
          emoji
          userId
          role
          createdAt
        }
        status
        createdAt
        updatedAt
      }
      lastMessageAt
      unreadCount
      matchId
    }
  }
`;

export const GET_MESSAGE_THREAD_MESSAGES = gql`
  query GetMessageThreadMessages($threadId: ID!, $limit: Int, $before: String) {
    getMessageThreadMessages(threadId: $threadId, limit: $limit, before: $before) {
      _id
      threadId
      senderId
      senderRole
      body
      attachments {
        _id
        url
        path
        title
      }
      replyTo {
        _id
        senderId
        senderRole
        body
        attachments {
          _id
          url
          path
          title
        }
        createdAt
        updatedAt
      }
      reactions {
        emoji
        userId
        role
        createdAt
      }
      status
      createdAt
      updatedAt
    }
  }
`;

export const SEND_MESSAGE = gql`
  mutation SendMessage($input: SendMessageInput!) {
    sendMessage(input: $input) {
      _id
      participants {
        userId
        role
        displayName
        avatarUrl
        lastReadAt
      }
      lastMessage {
        _id
        threadId
        senderId
        senderRole
        body
        attachments {
          _id
          url
          path
          title
        }
        replyTo {
          _id
          senderId
          senderRole
          body
          attachments {
            _id
            url
            path
            title
          }
          createdAt
          updatedAt
        }
        reactions {
          emoji
          userId
          role
          createdAt
        }
        status
        createdAt
        updatedAt
      }
      lastMessageAt
      unreadCount
      matchId
    }
  }
`;

export const MARK_MESSAGE_THREAD_READ = gql`
  mutation MarkMessageThreadRead(
    $threadId: ID!
    $userId: ID!
    $role: UserAccountType!
  ) {
    markMessageThreadRead(threadId: $threadId, userId: $userId, role: $role)
  }
`;

export const TOGGLE_MESSAGE_REACTION = gql`
  mutation ToggleMessageReaction(
    $messageId: ID!
    $userId: ID!
    $role: UserAccountType!
    $emoji: String!
  ) {
    toggleMessageReaction(
      messageId: $messageId
      userId: $userId
      role: $role
      emoji: $emoji
    ) {
      _id
      threadId
      senderId
      senderRole
      body
      attachments {
        _id
        url
        path
        title
      }
      replyTo {
        _id
        senderId
        senderRole
        body
        attachments {
          _id
          url
          path
          title
        }
        createdAt
        updatedAt
      }
      reactions {
        emoji
        userId
        role
        createdAt
      }
      status
      createdAt
      updatedAt
    }
  }
`;
